import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as createZone from "./createZone";
import * as editZone from "./editZone";
import * as removeZone from "./removeZone";
import * as retrieveCalendar from "./retrieveCalendar";
import * as retrieveZone from "./retrieveZone";
import * as retrieveZoneProjects from "./retrieveZoneProjects";
import * as retrieveZoneGantt from "./retrieveZoneGantt";
import * as retrieveZoneProjectsReports from "./retrieveZoneProjectsReports";
import * as retrieveZoneRole from "./retrieveZoneRole";
import * as retrieveZones from "./retrieveZones";
import * as retrieveZonesProjects from "./retrieveZonesProjects";
import * as retrieveZonesProjectsGantt from "./retrieveZonesProjectsGantt";
import * as retrieveZonesProjectsReports from "./retrieveZonesProjectsReports";
import * as transferProjects from "./transferProjects";
import * as retrieveGantt from "./retrieveGantt";
import * as retrieveZonesIndicators from "./retrieveZonesIndicators";
import * as retrieveOptimizedGantt from "./retrieveOptimizedGantt";
import * as retrieveGanttCalendarRange from "./retrieveGanttCalendarRange";

const initialState: State = {
  createZone: createZone.initialState,
  editZone: editZone.initialState,
  removeZone: removeZone.initialState,
  retrieveCalendar: retrieveCalendar.initialState,
  retrieveZone: retrieveZone.initialState,
  retrieveZoneProjects: retrieveZoneProjects.initialState,
  retrieveZoneGantt: retrieveZoneGantt.initialState,
  retrieveZoneProjectsReports: retrieveZoneProjectsReports.initialState,
  retrieveZoneRole: retrieveZoneRole.initialState,
  retrieveZones: retrieveZones.initialState,
  retrieveZonesProjects: retrieveZonesProjects.initialState,
  retrieveZonesProjectsGantt: retrieveZonesProjectsGantt.initialState,
  retrieveZonesProjectsReports: retrieveZonesProjectsReports.initialState,
  transferProjects: transferProjects.initialState,
  retrieveGantt: retrieveGantt.initialState,
  retrieveZonesIndicators: retrieveZonesIndicators.initialState,
  retrieveOptimizedGantt: retrieveOptimizedGantt.initialState,
  retrieveGanttCalendarRange: retrieveGanttCalendarRange.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createZone: createZone.reduceState,
  editZone: editZone.reduceState,
  removeZone: removeZone.reduceState,
  retrieveCalendar: retrieveCalendar.reduceState,
  retrieveZone: retrieveZone.reduceState,
  retrieveZoneProjects: retrieveZoneProjects.reduceState,
  retrieveZoneGantt: retrieveZoneGantt.reduceState,
  retrieveZoneProjectsReports: retrieveZoneProjectsReports.reduceState,
  retrieveZoneRole: retrieveZoneRole.reduceState,
  retrieveZones: retrieveZones.reduceState,
  retrieveZonesProjects: retrieveZonesProjects.reduceState,
  retrieveZonesProjectsGantt: retrieveZonesProjectsGantt.reduceState,
  retrieveZonesProjectsReports: retrieveZonesProjectsReports.reduceState,
  transferProjects: transferProjects.reduceState,
  retrieveGantt: retrieveGantt.reduceState,
  retrieveZonesIndicators: retrieveZonesIndicators.reduceState,
  retrieveOptimizedGantt: retrieveOptimizedGantt.reduceState,
  retrieveGanttCalendarRange: retrieveGanttCalendarRange.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createZone.createSelector(() => getState().createZone),
    ...editZone.createSelector(() => getState().editZone),
    ...removeZone.createSelector(() => getState().removeZone),
    ...retrieveCalendar.createSelector(() => getState().retrieveCalendar),
    ...retrieveZone.createSelector(() => getState().retrieveZone),
    ...retrieveZoneProjects.createSelector(
      () => getState().retrieveZoneProjects,
    ),
    ...retrieveZoneGantt.createSelector(() => getState().retrieveZoneGantt),
    ...retrieveZoneProjectsReports.createSelector(
      () => getState().retrieveZoneProjectsReports,
    ),
    ...retrieveZoneRole.createSelector(() => getState().retrieveZoneRole),
    ...retrieveZones.createSelector(() => getState().retrieveZones),
    ...retrieveZonesProjects.createSelector(
      () => getState().retrieveZonesProjects,
    ),
    ...retrieveZonesProjectsGantt.createSelector(
      () => getState().retrieveZonesProjectsGantt,
    ),
    ...retrieveZonesProjectsReports.createSelector(
      () => getState().retrieveZonesProjectsReports,
    ),
    ...transferProjects.createSelector(() => getState().transferProjects),
    ...retrieveGantt.createSelector(() => getState().retrieveGantt),
    ...retrieveZonesIndicators.createSelector(
      () => getState().retrieveZonesIndicators,
    ),
    ...retrieveOptimizedGantt.createSelector(
      () => getState().retrieveOptimizedGantt,
    ),
    ...retrieveGanttCalendarRange.createSelector(
      () => getState().retrieveGanttCalendarRange,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
